<template>
  <el-dialog
    title="增加冷藏箱"
    :visible="visible"
    v-if="visible"
    v-el-dialog-drag
    width="1000px"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <PackerIndex
      ref="packerIndex"
      :dispatchOrderCode="dispatchOrderCode"
      @close="close()"
    />
    <span slot="footer">
      <el-button @click="close()">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import PackerIndex from './index.vue'
export default {
  components: { PackerIndex },
  props: {
    visible: { type: Boolean, default: false },
    dispatchOrderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
